import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'

import languageManager from '../../../../services/languageManager'

import { Form, Input, InputNumber, Select, Divider } from 'antd'
import { CheckOutlined, CloseOutlined } from '@ant-design/icons'

const CustomerForm = (props) => {
    console.log(props.authState)
    const [isCustomer, setIsCustomer] = useState(!_.isNil(props.authState.userData.account.parent_account_id))
    const [supplierId, setSupplierId] = useState(!_.isNil(props.authState.userData.account.supplier) ? props.authState.userData.account.supplier.id : null)
    const [layout, setLayout] = useState(props.layout)
    const [values, setValues] = useState(props.values)

    const [form] = Form.useForm()
    const { Option } = Select

    useEffect(() => {
        setValues(props.values)
        if (_.isEmpty(props.values)) {
            form.resetFields()
        } else {
            console.log(props.values)
            form.setFieldsValue(props.values)
        }
    }, [props.values])

    const submitForm = (values) => {
        props.submitForm(values)
    }

    return (
        <Form
            form={form}
            {...layout}
            id="customerForm"
            name="customerForm"
            onFinish={submitForm}
        >
            {
                !isCustomer ? (
                    <Form.Item
                        label="Fornitore"
                        name="supplier_id"
                    >
                        <Select
                            showSearch
                            placeholder="Scegli il fornitore"
                            optionFilterProp="children"
                            allowClear={true}
                        >
                            {
                                props.supplierList.map((supplier) => {
                                    return <Option key={supplier.id} value={supplier.id}>{supplier.company}</Option>
                                })
                            }
                        </Select>
                    </Form.Item>
                ) : <Form.Item name="supplier_id" initialValue={supplierId} noStyle><Input type="hidden" /></Form.Item>
            }
            <Form.Item
                label="Codice interno"
                name="internal_code"
            >
                <Input disabled={isCustomer} />
            </Form.Item>
            <Form.Item
                label="Azienda"
                name="company_name"
                rules={[
                    {
                        required: true,
                        message: 'Inserisci il nome dell\'azienda',
                    },
                ]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                label="Partita IVA"
                name="vat"
            >
                <Input />
            </Form.Item>
            <Form.Item
                label="Codice Fiscale"
                name="fiscal_code"
                rules={[
                    {
                        required: false,
                        message: 'Inserisci il codice fiscale',
                    },
                ]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                label="SDI"
                name="sdi"
            >
                <Input />
            </Form.Item>
            <Form.Item
                label="Indirizzo email"
                name="email"
                rules={[
                    {
                        type: 'email',
                        required: false,
                        message: 'Inserisci un indirizzo email valido',
                    },
                ]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                label="PEC"
                name="pec"
                rules={[
                    {
                        type: 'email',
                        required: false,
                        message: 'Inserisci un indirizzo PEC valido',
                    },
                ]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                label="Telefono"
                name="phone"
            >
                <Input />
            </Form.Item>
            <Divider />
            <Form.Item
                label="Indirizzo"
                name="address_1"
            >
                <Input />
            </Form.Item>
            <Form.Item
                label="Indirizzo (opz.)"
                name="address_2"
            >
                <Input />
            </Form.Item>
            <Form.Item
                label="CAP"
                name="postal_code"
            >
                <Input />
            </Form.Item>
            <Form.Item
                label="Città"
                name="city"
            >
                <Input />
            </Form.Item>
            <Form.Item
                label="Provincia"
                name="state"
            >
                <Input />
            </Form.Item>
            <Form.Item
                label="Nazione"
                name="country"
            >
                <Input />
            </Form.Item>
            <Form.Item name="id" initialValue={values.itemId} noStyle><Input type="hidden" /></Form.Item>
            {/* <Form.Item name="language" initialValue={values.language} noStyle><Input type="hidden" /></Form.Item> */}
        </Form>
    )
}

const mapStateToProps = state => {
    return {
        authState: state.authenticationState,
        commonState: state.commonState,
    }
}

export default connect(mapStateToProps)(CustomerForm)